// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"60a05258","726":"b5dfb218","733":"f7ce31b3"}[chunkId] + ".chunk.js";
};